import React from 'react';

import { Box } from '@mui/material';

import { RATING_BADGE_STYLES, SCORE_CARD_SX } from './constants';

interface ScorePillProps {
  ring: React.ReactNode;
  rating: string;
  alertText: string;
}

export default function ScorePill({ ring, rating, alertText }: ScorePillProps) {
  const style = RATING_BADGE_STYLES[rating] ?? RATING_BADGE_STYLES.POOR;
  return (
    <Box sx={SCORE_CARD_SX}>
      <Box sx={{ mb: 1.5 }}>{ring}</Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 1,
          px: 2,
          py: 1,
          bgcolor: style.bgcolor,
          color: style.color,
          borderRadius: '12px',
          fontSize: 13,
          fontWeight: 600,
          width: '100%',
          textAlign: 'left',
        }}
      >
        <Box
          sx={{
            flexShrink: 0,
            width: 20,
            height: 20,
            bgcolor: style.iconBg,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontSize: 12,
          }}
        >
          {style.icon}
        </Box>
        <Box
          component="span"
          sx={{
            flex: 1,
            minWidth: 0,
            overflowWrap: 'break-word',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
          }}
        >
          {alertText}
        </Box>
      </Box>
    </Box>
  );
}
